function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.11 9a9 9 0 11-18 0 9 9 0 0118 0zm-4.467-3.409a.843.843 0 00-1.215.025l-3.907 4.978-2.355-2.356a.844.844 0 00-1.192 1.193l2.977 2.978a.843.843 0 001.214-.023l4.49-5.613a.844.844 0 00-.01-1.182h-.002z",
  fill: "#50A684"
});

function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGreenCheck;